import { api } from "../services/index";

export function getContracts() {
  return api.get("/contracts");
}

export function addContract(data) {
  return api.post("/contracts", data);
}

export function editContract(contractID, data) {
  return api.patch(`/contracts/${contractID}`, data);
}

export function getContract(contractID) {
  return api.get(`/contracts/${contractID}`);
}

export function getContractApps(contractID) {
  return api.get(`/contracts/${contractID}/apps`);
}

export function deleteContract(contractID) {
  return api.delete(`/contracts/${contractID}`);
}

export function addApp(contractID, appID) {
  return api.post(`/contracts/${contractID}/apps/${appID}`);
}

export function removeApp(contractID, appID) {
  return api.delete(`/contracts/${contractID}/apps/${appID}`);
}

export function addAuthorizer(contractID, authorizerID) {
  return api.post(`/contracts/${contractID}/authorizers/${authorizerID}`);
}

export function removeAuthorizer(contractID, authorizerID) {
  return api.delete(`/contracts/${contractID}/authorizers/${authorizerID}`);
}

export function getCustomers() {
  return api.get("/customers");
}

export function getAuthorizers() {
  return api.get("/authorizers");
}
